// extracted by mini-css-extract-plugin
export var active = "faq-box-module--active--kXNfq";
export var faq__answer = "faq-box-module--faq__answer--etWEI";
export var faq__answerText = "faq-box-module--faq__answer-text--DhWkr";
export var faq__question = "faq-box-module--faq__question--wC8Ic";
export var faq__toggle = "faq-box-module--faq__toggle--lRYEc";